import { useEffect } from 'react'
import { OptionsHOC } from '../../hocs'

const triggerWindowLoad = () => {
  const event = document.createEvent('Event')
  event.initEvent('load', true, true)
  window.dispatchEvent(event)
}

const ScriptInject = ({ getOption }) => {

  useEffect(() => {
    const headerScripts = getOption('headerScripts')

    if (headerScripts) {
      document.head.insertAdjacentHTML('beforeend', headerScripts)
      // Trigger window load manually to active any injected scripts
      triggerWindowLoad()
    }
  })

  return null
}

export default OptionsHOC(ScriptInject)



// WEBPACK FOOTER //
// ./src/components/ScriptInject/index.js